import React from "react"
import ReactDOM from "react-dom/client"
import { initPosthog } from "@/lib/posthog"

import "./i18n/index.ts"
import App from "./App.tsx"
import "./index.css"

// PostHog (Session Replay)
initPosthog()

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
